import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ACCESS_FILES_API_KEY,
  BASE_IMAGES_URL,
  COMMON_FAIL_MESSAGE,
} from "Constants";
import TemplatePreview from "../../template_preview";
// import TemplateSetting from './template_setting_modal';
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import { fetchEventDetails } from "DashboardUserAction";
import {
  addSelectedTemplate,
  updateSelectedTheme,
  deployTemplate,
} from "TemplatesAction";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";
import Button from "react-bootstrap-button-loader";

import {
  saveTemplateThemeData,
  fetchPreviewImgPath,
  resetTemplateImageath,
} from "../../actions";

class TemplateCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showTemplatePreviewModal: false,
      showSettingModel: false,
    };
  }

  componentDidMount() {
    this.props.fetchEventDetails(this.props.session);
  }

  openPreview = (e) => {
    this.setState({ showTemplatePreviewModal: true });
  };

  closePreview = (e) => {
    this.setState({ showTemplatePreviewModal: false });
  };
  openSetting = (e) => {
    // this.setState({showSettingModel: true});
    var { eventSelectedTemplate, templateObj, session, callfrom } = this.props;
    var disableSelectBtn = false;
    var templateid = templateObj.id;
    var selectedTemId = templateObj.id;

    if (
      eventSelectedTemplate &&
      eventSelectedTemplate.length > 0 &&
      templateObj.id != eventSelectedTemplate[0].templateid
    ) {
      disableSelectBtn = true;
      selectedTemId = eventSelectedTemplate[0].id;
    }
    confirmAlert({
      title: LocaleStrings.website_theme_text_template,
      message: `${LocaleStrings.website_theme_text_template_sub_title}?`,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            if (disableSelectBtn) {
              this.props.updateSelectedTheme(
                session,
                templateid,
                selectedTemId,
                (response) => {
                  if (response.success) {
                    this.props.deployTemplate(
                      templateObj.modulepath,
                      eventSelectedTemplate[0].website_subdomain,
                      (response) => {
                        if (response.success === 0) {
                          this.props.showError(
                            LocaleStrings.website_theme_selected_depolying_error
                          );
                        } else {
                          this.props.showSuccess(
                            LocaleStrings.website_theme_updated_new_success
                          );
                        }
                      }
                    );
                  } else {
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  }
                }
              );

              if (callfrom && callfrom === "wizard") {
                this.props.saveTemplateThemeData(templateObj);
              }
            } else {
              this.props.addSelectedTemplate(
                session,
                selectedTemId,
                (response) => {
                  if (response.success) {
                    this.props.showSuccess(
                      LocaleStrings.website_theme_selected_new_success
                    );
                  } else {
                    this.props.showError(COMMON_FAIL_MESSAGE);
                  }
                }
              );

              if (callfrom && callfrom === "wizard") {
                this.props.saveTemplateThemeData(templateObj);
              }
            }
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  };

  // closeSetting = (e) => {
  //   this.setState({showSettingModel: false});
  // }

  openWebsite = () => {
    var url = this.props.eventSelectedTemplate[0].website_url;
    window.open(url, "_blank");

    //this.props.websiteCreationCallback(url);
  };

  // onOptionChange = (e) => {
  //     let clickedValue = e.target.value;
  //     if (clickedValue === 'free') {
  //         this.props.saveOptionStatePublish({ free: true, paid: false });
  //         this.props.saveSelectedPlan({});
  //         this.setState({selectedPlan: {}});
  //     }
  //     else {
  //         this.props.saveOptionStatePublish({ free: false, paid: true })
  //     }
  // }

  openPreviewImg = () => {
    this.props.resetTemplateImageath();
    this.props.fetchPreviewImgPath(
      this.props.session,
      this.props.templateObj,
      (res) => {
        // if(res.success){
        //    this.openPreview();
        // }
        // else{
        //     this.showError("Preview image could not be loaded.")
        // }
      }
    );
    this.openPreview();
  };

  render() {
    var { templateObj, eventSelectedTemplate } = this.props;
    var { showTemplatePreviewModal, showSettingModel } = this.state;

    var imageurl = `${BASE_IMAGES_URL}/${templateObj.template_thumb}?api_key=${ACCESS_FILES_API_KEY}`;
    var repairing = `../../style/images/icons/repairing-service.png`;

    let disableSelectBtn = false;
    let select = LocaleStrings.button_select;
    if (
      eventSelectedTemplate.length > 0 &&
      templateObj.id === eventSelectedTemplate[0].templateid
    ) {
      disableSelectBtn = true;
    }

    var containerStyle = "template-cell";
    var cssStyle = "thumbStyle";
    var showgray = false;

    // var previewStyle={height: '50%', paddingTop: '12%'};
    var previewStyle = { height: "50%", paddingTop: "24%" };

    // if(disableSelectBtn){
    //   previewStyle={height: '50%', paddingTop: '24%'};
    // }

    //This defines that a Template has been chosen other template options are grayed out
    // if(eventSelectedTemplate.length > 0 && templateObj.id != eventSelectedTemplate[0].templateid){
    //   showgray=true;
    //   cssStyle="thumbStyle grayimage";
    //   containerStyle="disabled-template-cell"
    // }

    //This logic is temporary until all designs are ready
    // if((eventSelectedTemplate.length > 0 && templateObj.id === eventSelectedTemplate[0].templateid) || templateObj.template_name === 'Coming Soon'){
    //   showgray=true;
    //   cssStyle="thumbStyle grayimage";
    //   containerStyle="disabled-template-cell"
    // }
    if (templateObj.template_name === "Coming Soon") {
      showgray = true;
      cssStyle = "thumbStyle grayimage";
      containerStyle = "disabled-template-cell";
    }

    return (
      <div>
        {/* <input
                    name="option"
                    type="radio"
                    value={templateObj.id}
                    onChange={(e) => this.onOptionChange(e)}
                    checked={optionStatePublish && !_.isEmpty(optionStatePublish) ? optionStatePublish.free : false}
                /> */}
        <div className={containerStyle}>
          <img src={imageurl} className={cssStyle} />
          <div>{templateObj.template_name}</div>
          {
            //   <div className={disableSelectBtn?"overlay-options-visible":"overlay-options"}>
            <div className="overlay-options">
              <div style={previewStyle}>
                {/* <Button
                                    
                                    className="btn-custom-white"
                                    style={{ height: 40, width: 120 }}
                                    // onClick={(disableSelectBtn && eventSelectedTemplate[0].website_url) ? this.openWebsite: disableSelectBtn ? null : this.openPreview}
                                    onClick={this.openPreview}
                                >
                                    <i className="fa fa-eye fa-lg i-custom-m" aria-hidden="true"></i>
                                    // {(disableSelectBtn && eventSelectedTemplate[0].website_url) ? LocaleStrings.button_open : disableSelectBtn ? LocaleStrings.button_selected : LocaleStrings.button_preview}
                                    {LocaleStrings.button_preview}
                                </Button> */}

                <Button
                  className="btn-custom-white"
                  style={{ height: 40, width: 120 }}
                  onClick={this.openPreviewImg}
                >
                  <i
                    className="fa fa-eye fa-lg i-custom-m"
                    aria-hidden="true"
                  ></i>
                  {LocaleStrings.button_preview}
                </Button>
              </div>
              {disableSelectBtn ? null : (
                <div style={{ height: "50%", paddingTop: "2%" }}>
                  {/* className="btn-custom-blue templateOptionButton" */}
                  {/* <Button  className="btn-custom-blue" style={{height: 40, width: 120}} onClick={this.openSetting}><img className="i-custom-m" style={{padding: 0, margin: 0}} src={repairing} style={{width: '23%'}}/>{select}</Button> */}
                </div>
              )}
            </div>
          }
          <div>
            {showTemplatePreviewModal ? (
              <TemplatePreview
                openTemplateModel={showTemplatePreviewModal}
                closePreview={this.closePreview}
                templateObj={templateObj}
              />
            ) : (
              ""
            )}
            {/* {showSettingModel ? <TemplateSetting openSettingModel={showSettingModel} closeSetting={this.closeSetting} templateObj={templateObj} websiteCreationCallback={this.props.websiteCreationCallback}/> : ''} */}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    eventDetails: state.userEventDetails,
  };
}

export default connect(mapStateToProps, {
  fetchEventDetails,
  addSelectedTemplate,
  updateSelectedTheme,
  deployTemplate,
  showError,
  showSuccess,
  saveTemplateThemeData,
  fetchPreviewImgPath,
  resetTemplateImageath,
})(TemplateCell);
